<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 6L7.99999 12M7.99999 12L14 18M7.99999 12L21 12" stroke="#F6F6F6" stroke-linejoin="round" />
    <path d="M5.5 18L5.5 6" stroke="#F6F6F6" />
  </svg>
</template>

<style scoped>
svg {
  width: 24px;
  height: 24px;
}
</style>
